import { FunctionComponent } from "react";
import { Separator, Stack } from "@bps/fluent-ui";
import { PltUser } from "@libs/api/gateways/plt/plt-gateway.dtos";

import { UserSecurityForm } from "./UserSecurityForm";
import {
  useAssignedUserSecurityRoles,
  useSecurityBusinessRoles,
  useUserRoles
} from "@libs/api/gateways/plt/plt-gateway.hooks";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { getUserSecurityInitialValues } from "./user-security.utils";

interface UserSecurityProps {
  user: PltUser;
}

export const UserSecurity: FunctionComponent<UserSecurityProps> = ({
  user
}) => {
  const userRolesQuery = useUserRoles(user.tenantId, user.id);
  const businessRolesQuery = useSecurityBusinessRoles({
    tenantId: user.tenantId
  });

  const assignedUserRolesQuery = useAssignedUserSecurityRoles({
    userId: user?.id,
    tenantId: user?.tenantId,
    businessRoles: userRolesQuery.data?.businessRoles ?? []
  });

  const isLoading =
    userRolesQuery?.isLoading ||
    assignedUserRolesQuery?.isLoading ||
    businessRolesQuery?.isLoading;

  const error =
    userRolesQuery?.error ??
    assignedUserRolesQuery.error ??
    businessRolesQuery?.error;

  return (
    <Stack>
      <Separator />
      <QueryStateIndicator
        data={{
          userRoles: userRolesQuery.data,
          assignedUserRoles: assignedUserRolesQuery.data
        }}
        isLoading={isLoading}
        error={error}
      >
        {({ userRoles, assignedUserRoles }) => {
          const initialValues = getUserSecurityInitialValues(
            assignedUserRoles ?? [],
            userRoles?.businessRoles ?? []
          );

          return <UserSecurityForm user={user} initialValues={initialValues} />;
        }}
      </QueryStateIndicator>
    </Stack>
  );
};
